export default "__VITE_ASSET__DrrwRPQb__"